<template>
    <v-dialog v-model="showDialog" persistent max-width="900px" @keydown.esc="$emit('cancelDialog')">
        <progress-overlay :Loading="Loading"></progress-overlay>
        <VuePerfectScrollbar class="drawer-menu--scroll" style="height:80vh">
            <v-card>
                <v-card-title>
                    <span v-if="NewCohort" class="headline">Create New Cohort: Cohort-{{ CohortName }}</span>
                    <span v-else class="headline">Edit Cohort: {{ CohortName }}</span>
                    <v-spacer></v-spacer>
                    <div>
                        <v-btn color="blue darken-3" @click="saveCohort" small>Save</v-btn>
                    </div>
                    <div class="ma-0 pl-1">
                        <v-btn color="grey darken-1" @click="$emit('cancelDialog')" small>Cancel</v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-flex xs12>
                        <span v-if="showError" class="red--text">Please select at least one segment!</span>
                    </v-flex>
                    <v-flex xs12>
                        <span>Please select segment filters to add in your Cohort.</span>
                    </v-flex>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex v-for="category in CategoriesSegment" :key="category.categoryName" xs4>
                                <v-card color="grey lighten-3" height="100%">
                                    <v-card-title>
                                        <span><strong>{{ category.categoryName }}</strong></span>
                                    </v-card-title>
                                    <v-card-text v-for="keyval in category.keyValues" :key="keyval.itemName" class="ma-0 pa-0 pb-1">
                                        <v-checkbox :label="keyval.itemName"
                                                    :value="keyval.itemValue"
                                                    color="indigo"
                                                    v-model="modelNewCohortFilters" class="ma-0 pa-0"
                                                    hide-details></v-checkbox>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <div>
                        <v-btn color="blue darken-3" @click="saveCohort" small>Save</v-btn>
                    </div>
                    <div class="ma-0 pl-1">
                        <v-btn color="grey darken-1" @click="$emit('cancelDialog')" small>Cancel</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </VuePerfectScrollbar>
    </v-dialog>
</template>
<script>
    import { mapState } from 'vuex';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import ProgressOverlay from '../_partial/ProgressOverlay'

    export default {
        components: {
            VuePerfectScrollbar,
            ProgressOverlay
        },
        props: [
            'CategoriesSegment',
            'Dialog',
            'CohortName',
            'NewCohort',
            'CohortID'
        ],
        data() {
            return {
                Loading: false,
                modelNewCohortFilters: [],
                showDialog: false,
                showError: false,
                userSettingId: 0
            }
        },
        watch: {
            Dialog: function (newVal) {
                this.isError = false;
                this.modelNewCohortFilters = [];
                this.showDialog = newVal;
            },
            CohortID: function (newVal) {
                //console.log(newVal);
                this.modelNewCohortFilters = [];
                for (var itemEdit of this.userSettingData) {
                    if (itemEdit.userSettingId == newVal) {
                        for (var itemUS of itemEdit.itemValues) {
                            this.modelNewCohortFilters.push(itemUS.itemResponseValue);
                        }
                    }
                }
            },
        },
        computed: {
            ...mapState({
                tblCohortFilters: state => state.CategoriesStore.tblCohortFilters,
                modelCohortFilters: state => state.CategoriesStore.modelCohortFilters,
                userSettingData: state => state.UserSettingStore.userSettingData
            }),
        },
        methods: {
            saveCohort() {
                if (this.modelNewCohortFilters.length == 0) {
                    this.showDialog = true;
                    this.showError = true;
                }
                else {
                    var alertMessage = ''
                    if (this.NewCohort == true) {
                        this.userSettingId = -1;
                        alertMessage = 'Cohort-' + this.CohortName + ' saved successfully.';
                    }
                    else {
                        this.userSettingId = this.CohortID
                        alertMessage = this.CohortName + ' updated successfully.';
                    }
                    var userSettingDataUpdate = {
                        userSettingId: this.userSettingId,
                        modelNewCohortFilters: this.modelNewCohortFilters,
                        cohortName: 'Cohort-' + this.CohortName
                    }
                    //console.log(userSettingDataUpdate)
                    this.$store.dispatch('UserSettingStore/saveUserSettingData', userSettingDataUpdate)
                        .then(() => {
                            this.$store.dispatch('UserSettingStore/getUserSettingData')
                                .then(() => {
                                    if (!this.NewCohort) {
                                        //this.$store.dispatch('UserSettingStore/getUserSettingData');
                                        var selectedUserSettings = [];
                                        for (var i = 0; i < this.userSettingData.length; i++) {
                                            if (this.userSettingData[i].showOnDefault) {
                                                var name = this.userSettingData[i].settingName;
                                                let id = this.userSettingData[i].userSettingId;
                                                var userSetting = {
                                                    settingName: name,
                                                    userSettingId: id,
                                                    itemValues: []
                                                }
                                                userSetting.itemValues = this.userSettingData[i].itemValues;
                                                selectedUserSettings.push(userSetting);
                                            }
                                        }
                                        this.$store.dispatch('UserSettingStore/settblCohortListFilters', selectedUserSettings);

                                        var countMeasure = 0
                                        for (var k = 0; k < this.tblCohortFilters.length; k++) {
                                            var measure = this.tblCohortFilters[k];
                                            if (measure.categoryName == "Measures") {
                                                countMeasure = this.tblCohortFilters[k].keyValues.length;
                                            }
                                        }
                                        if (countMeasure > 0) {

                                            this.Loading = true;
                                            this.$store.dispatch('SegmentMeasureStore/resetCompositeQuestionText')
                                            this.$store.dispatch('SegmentMeasureStore/getCompositeQuestionTextForCohort')
                                                .then(() => {
                                                }).catch(error => {
                                                    this.Loading = false;
                                                    this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                                                })
                                            this.$store.dispatch('SegmentMeasureStore/GetClientDataWithCohort')
                                                .then(() => {
                                                    this.Loading = false;
                                                }).catch(error => {
                                                    this.Loading = false;
                                                    this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                                                })
                                        }
                                    }
                                }).catch(error => {
                                    //this.Loading = false;
                                    this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                                })

                            this.$store.dispatch('AppStore/SetAlert', { alert: alertMessage, isError: false })
                        }).catch(error => {
                            //this.Loading = false;
                            this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                        })
                    this.showDialog = false;
                    this.showError = false;
                    this.$emit('cancelDialog');

                    
                }
            }
        }
    }
</script>
<style scoped>
    .drawer-menu--scroll {
        height: auto;
        overflow: auto;
    }
</style>